import { forwardRef } from 'react';
import { BaseButton, type BaseButtonProps } from '@/Components/Common/Buttons/BaseButton';
import { cn } from '@/lib/utils';

const SecondaryButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
    ({ className, ...props }, ref) => {
        return (
            <BaseButton ref={ref} variant="secondary" className={cn(className)} {...props} />
        );
    },
);
SecondaryButton.displayName = 'SecondaryButton';

export { SecondaryButton };
